import * as _ from 'lodash'
import bootbox from 'bootbox'

// =============================================================================
// savePreferences - store user settings in localStorage
// =============================================================================
export function saveUserPreferences() {
    localStorage.setItem( 'preferences#main-1', JSON.stringify( globals.vars.userPreferences ) )
}

// =============================================================================
// getPreferences - read user settings from localStorage
// =============================================================================
export function loadUserPreferences() {
    var p = null

    try {
        p = JSON.parse(localStorage.getItem('preferences#main-1'))
    } catch (error) {
    }

    if (p != null)
        globals.vars.userPreferences = p
}

// export function formatStatsUSD(val: string): string {
//     // @ts-ignore
//     return val == '-' || isNaN(val) ? '0'.toLocaleString(_vars.locales, { minimumFractionDigits: 2 }) : Math.abs(parseFloat(val)) > 10000 ? parseInt(Math.round(parseFloat(val) *100) / 100).toLocaleString(_vars.locales, { }) : (parseFloat(Math.round(parseFloat(val) *100) / 100).toLocaleString(_vars.locales, { minimumFractionDigits: 2 }))
// }

export function setCookie(cName: string, cValue: string, expDays: number) {
    let date = new Date()
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000))
    const expires = "expires=" + date.toUTCString()
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/; SameSite=Lax"
}

export function getCookie(cName:string): string {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${cName}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
}

export function anonFigures(value: string): string {
    if (helpers.appSettingsGet('privacyMode') !== null)
        return value.replace(/[^0-9]+/mg, '').replace(/[0-9]+/mg, '****')
    else
        return value
}

export function appSettingsSet(data: object = {}) : object {
    const stored = localStorage.getItem('mybanks_settings')

    let settings = stored !== null ? JSON.parse(stored) : {}

    Object.assign(settings, data)

    localStorage.setItem('mybanks_settings', JSON.stringify(settings))
    return settings
}

export function appSettingsGet(key?: string) : any {
    const stored = localStorage.getItem('mybanks_settings')

    if (stored == null)
        return null

    const settings = stored !== null ? JSON.parse(stored) : {}

    if (typeof key === 'undefined')
        return settings

    if (typeof settings[key] === 'undefined')
        return null
    else
        return settings[key]
}

export function appSettingsDelete(key: string) {
    const stored = localStorage.getItem('mybanks_settings')

    const settings = stored !== null ? JSON.parse(stored) : {}

    if (typeof key !== 'undefined' && typeof settings[key] !== 'undefined') {
        delete settings[key]
        localStorage.setItem('mybanks_settings', JSON.stringify(settings))
    }
}

export function fmtCurrency(input: number, currency: string = 'EUR', decimals: number = 2): string {
    return new Intl.NumberFormat(globals.vars.locales, { minimumFractionDigits: decimals, maximumFractionDigits: decimals, style: "currency", currency: currency }).format(input)
}

export function alert(message: string | object, title: string = global.i18n.t('dialogs.error'), done?: (result: any) => void) {
    if (title === null)
        title = global.i18n.t('dialogs.error')

    console.log(title, message)

    if (typeof message === 'object')
        message = '<pre>'+JSON.stringify(message, null, 2)+'</pre>'

    bootbox.confirm({
        title: title,
        message: message,
        centerVertical: true,
        buttons: {
            cancel: {
                className: 'visually-hidden'
            },
            confirm: {
                label:  global.i18n.t('buttons.ok'),
                className: 'btn-primary',
            }
        },
        callback: function (result) {
            if (typeof done === 'function')
                done(result)                
        }
    })
}

export function ucFirst(str: string) : string {
    return str.replace(/^./, char => char.toUpperCase())
}
